import {useState} from 'react';

const map = [
    [
        'What is the Bonus Zone?', 
        'It’s a special mission zone. Complete tasks, earn diamonds, and spend them on amazing rewards.'
    ],
    [
        'How do I earn diamonds?',
        'Simply complete daily, weekly, and special tasks. The more tasks you finish, the more diamonds you collect.'
    ],
    [
        'Where can I spend my diamonds?',
        'In the Bonus Zone shop you can:<br><br>💵 Purchase real balance with withdrawal option<br>🎁 Open loot boxes with a chance to win big cash prizes<br>👑 Unlock VIP benefits and exclusive perks<br>🔥 Discover many more rewards (updated regularly)'
    ],
    [
        'Are there any limits on using diamonds?',
        'No. Diamonds are fully yours to spend however you like.'
    ],
    [
        'How can I become VIP and get more?',
        'Level up through your activity, unlock VIP privileges, and boost your rewards.'
    ]
]

export default () => {
    const [active_question, setActiveQuestion] = useState(null);

    return (
        <div className="faq">
            <div className="title">FAQ</div>

            <div className="faq-items">
                {map.map((a, key) => {
                    return (
                        <div key={key} className={`faq-item  ${active_question === key ? 'active' : ''}`} onClick={e => setActiveQuestion(key === active_question ? null : key)}>
                            <div className="faq-question">
                                <span>{a[0]}</span>

                                <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.71074 8.94998L11.9447 15.47C12.799 16.24 14.1969 16.24 15.0512 15.47L22.2852 8.94999" stroke="#30344F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div className="faq-answer" dangerouslySetInnerHTML={{__html: a[1]}}></div>
                        </div> 
                    )
                })}
            </div>
        </div> 
    )
}